import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'contact-bulk-actions',
	templateUrl: './contact-bulk-actions.component.html',
	styleUrls: ['./contact-bulk-actions.component.scss'],
})
export class ContactBulkActionsComponent {
	@Input() selectedContacts: any[] = [];
	@Output() onSendMessage: EventEmitter<any> = new EventEmitter<any>();

	constructor() {}

	isBullkMessagesModalOpen = false;
}
